import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { FetchMoreQueryOptions } from '@apollo/client';
import {
  JobsLandingAds as BrandImages,
  StyledImg,
}
  from '@fuww/library/src/JobsLanding';
import CompanyPage
  from '@fuww/library/src/Layouts/CompanyPage';
import TextWithImage from '../components/TextWithImage';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import Hero from '../components/Hero';
import Articles from '../components/News/ArticleFeed';
import withQuery from '../lib/withQuery';
import articlesConnectionQuery
  from '../lib/queries/news/articlesConnectionQuery.graphql';
import getPartnerVariables from '../lib/getPartnerVariables';
import { useSiteContext } from '../components/SiteContext';
import { textWithImageConfigurations }
  from '../lib/imageConfigurations';
import withApollo from '../lib/apollo';
import getSourceSet from '../lib/getSourceSet';
import createCompanyBreadcrumbs from '../lib/createCompanyBreadcrumbs';
import {
  ArticlesConnectionQuery,
  ArticlesConnectionQueryVariables,
} from '../lib/graphql/api/graphql';

const companies = [
  {
    logo: 'https://fashionunited.com/global-assets/fu20164/dist/landing/images/superdry_logo.svg',
    name: 'Superdry',
  },
  {
    logo: 'https://fashionunited.com/global-assets/fu20164/dist/landing/images/hugoboss_logo.svg',
    name: 'Hugo Boss',
  },
  {
    logo: 'https://fashionunited.com/global-assets/fu20164/dist/landing/images/zalando_logo.svg',
    name: 'Zalando',
  },
  {
    logo: 'https://fashionunited.com/global-assets/fu20164/dist/landing/images/adidas_logo.svg',
    name: 'Adidas',
  },
];
const imageUrls = {
  employerBranding: [
    'https://r.fashionunited.com/WcblGz8ShCcfjdlLN_bPyRSz5XfmJbzDEn_nImNZmPo/resize:fill:42:28:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9lbXBsb3llci1icmFuZGluZy1wYWdlLnBuZw',
    'https://r.fashionunited.com/vLJMB9-vSaCEhYXpJYjaYlACNmCb_3G4PqjzxX6dReU/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9lbXBsb3llci1icmFuZGluZy1wYWdlLnBuZw',
    'https://r.fashionunited.com/xPRItjAcw4ogOe80wWDJEukIg3yHF8hcDkDjZs36jyo/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9lbXBsb3llci1icmFuZGluZy1wYWdlLnBuZw',
    'https://r.fashionunited.com/GBwPeEsu26Renak3Zyqnd5-Egsfiv-0rD9rj6XFsj2M/resize:fill:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9lbXBsb3llci1icmFuZGluZy1wYWdlLnBuZw',
  ],
  displayAdvertising: [
    'https://r.fashionunited.com/nDhEXOqRyY8f2H45uP_PiM77ESlVF-s1gHscf1vdnCw/resize:fill:42:28:0/gravity:ce/quality:10/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5LWFkdmVydGlzaW5nLXBhZ2UucG5n',
    'https://r.fashionunited.com/wicPoMpVr3FnhKAPKjiAej25QU5Kha8LCiH3tJ5Gt4k/resize:fill:360:240:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5LWFkdmVydGlzaW5nLXBhZ2UucG5n',
    'https://r.fashionunited.com/XvE8DzzLLldf5QaIIgMMP3HRl2ag5fqDCZmR_P1w4BI/resize:fill:460:307:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5LWFkdmVydGlzaW5nLXBhZ2UucG5n',
    'https://r.fashionunited.com/bIyEM0ijKkipgpzz7TUZkZtEc6kmH0k4qq0KngB2Sx0/resize:fill:920:614:0/gravity:ce/quality:70/aHR0cHM6Ly9zdG9yYWdlLmdvb2dsZWFwaXMuY29tL21lZGlhLWZhc2hpb251bml0ZWQtY29tL21lZGlhL2ltYWdlcy9kaXNwbGF5LWFkdmVydGlzaW5nLXBhZ2UucG5n',
  ],
};

const logos = companies.slice(0, 4).map((image) => (
  <BrandImages key={image.name}>
    <StyledImg src={image.logo} alt={image.name} />
  </BrandImages>
));

export interface CompanyPageWithDataProperties {
  data: ArticlesConnectionQuery;
  fetchMore: (variables: FetchMoreQueryOptions<
    ArticlesConnectionQueryVariables
  >) => void;
  loading: boolean;
  variables: ArticlesConnectionQueryVariables;
}

const EmployerBranding = ({
  data,
  fetchMore,
  loading,
  variables,
}: CompanyPageWithDataProperties) => {
  const intl = useIntl();

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: 'employer-branding',
    crumbLabel: intl.formatMessage(messages['employerBranding.header']),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(messages['employerBranding.header'])}
        description={intl.formatMessage(messages['employerBranding.subHeader'])}
      />
      <CompanyPage
        advertorials={(
          <Articles
            data={data}
            fetchMore={fetchMore}
            loading={loading}
            preloadFirst
            variables={variables}
          />
        )}
        breadcrumbs={breadcrumbs}
        description={intl.formatMessage(messages['employerBranding.subHeader'])}
        logos={logos}
        logosTitle={intl.formatMessage(
          messages['employerBranding.brandsHiring'],
        )}
        textWithImageComponents={(
          <>
            <TextWithImage
              buttonLabel={intl.formatMessage(messages[
                'employerBranding.buttonLabel'
              ])}
              buttonRoute="contact"
              description={intl.formatMessage(
                messages['employerBranding.ebpBody'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.employerBranding}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.employerBranding,
              )}
              title={intl.formatMessage(messages['employerBranding.ebpHeader'])}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(messages[
                'employerBranding.buttonLabel'
              ])}
              buttonRoute="contact"
              description={intl.formatMessage(
                messages['employerBranding.advertorialsBody'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.displayAdvertising}
              srcSet={getSourceSet(
                textWithImageConfigurations,
                imageUrls.displayAdvertising,
              )}
              title={intl.formatMessage(
                messages['employerBranding.advertorialsHeader'],
              )}
            />
          </>
        )}
        title={intl.formatMessage(messages['employerBranding.header'])}
      />
    </>
  );
};

const EmployerBrandingWithQuery = withQuery<
  ArticlesConnectionQuery,
  ArticlesConnectionQueryVariables
>(EmployerBranding);

const EmployerBrandingPage: NextPageWithLayout = () => {
  const { newsboard } = useSiteContext();

  return (
    <EmployerBrandingWithQuery
      errorMessage="Error while loading news articles"
      query={articlesConnectionQuery}
      variables={getPartnerVariables(newsboard)}
    />
  );
};

EmployerBrandingPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Employer branding banner image"
      />
    )}
  >
    {page}
  </Layout>
);

export default withApollo(EmployerBrandingPage);
